import { formatDateLong } from '../../../Functions';

export function DeliveryList(XLSX, data) {
    // console.log(data)
    var todayDate = new Date();

    var wb = XLSX.utils.book_new();

    var ws = XLSX.utils.json_to_sheet(
        [
            { A: '', B: '', C: '', D: '', E: 'OCEAN TRANSPORT GROUP OF COMPANIES INC.' },
            { A: '', B: '', C: '', D: '', E: '', F: 'DELIVERY LIST' },
            { A: '' },
            { A: '', B: formatDateLong(todayDate), C: 'Booking Date', D: 'Customer', E: 'Destination', F: 'Pick up / Delivery Address', G: 'Booking #', H: 'Service Mode' }
        ]
        , { header: [], skipHeader: true });

    if (data && data.length > 0) {
        data.forEach((ele, id) => {
            var DataToDate = new Date(ele.bookingDate);
            let formatted_date = (DataToDate.getMonth() + 1) + "-" + DataToDate.getDate() + "-" + DataToDate.getFullYear();
            XLSX.utils.sheet_add_json(ws, [
                {
                    A: id + 1,
                    B: ele.remarks,
                    C: formatted_date,
                    D: ele.customer,
                    E: ele.destination,
                    F: ele.address,
                    G: ele.bookingRef,
                    H: ele.modeOfDelivery
                }
            ], { header: [], skipHeader: true, origin: -1 });
        });
    }

    var wscols = [
        { wch: 6 }, // Number
        { wch: 25 }, // Remarks
        { wch: 11 }, // Booking Date
        { wch: 25 }, // Customer
        { wch: 9 }, // Destination
        { wch: 35 }, // Address
        { wch: 15 }, // Booking Number
        { wch: 15 }, // Service Mode
    ];
    ws['!cols'] = wscols;

    XLSX.utils.book_append_sheet(wb, ws, "Delivery List");

    XLSX.writeFile(wb, "Delivery_List.xlsx");
};